import { Component, Input } from "@angular/core";
import { AbstractControl } from "@angular/forms";

@Component({
    template: '',
    standalone: false
})
export class BaseStepComponent<T = any> {
  @Input() allValues: T;
  @Input() form: AbstractControl;
}